import { render, staticRenderFns } from "./inactive_school.vue?vue&type=template&id=0382192f"
import script from "./inactive_school.vue?vue&type=script&lang=js"
export * from "./inactive_school.vue?vue&type=script&lang=js"
import style0 from "./inactive_school.vue?vue&type=style&index=0&id=0382192f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports